import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';
import CompatibleWithHelper from '../utils/CompatibleWithHelper';

class CompatibleWith extends React.Component {
  render() {
    const productName = this.props[CompatibleWithHelper.keyMap.compatibleWith];

    if (!productName) {
      return null;
    }

    // FormattedHTMLMessage is deprecated, but since we're passing in sanitized data via
    // ReactHtmlParser, we should be fine
    return (
      <div className="xrs-compatible-with">
        <FormattedHTMLMessage
          id="CompatibleWith.compatible_message"
          defaultMessage="This product is compatible with <strong>{productName}</strong>"
          values={{ productName: ReactHtmlParser(productName) }}
        />
      </div>
    );
  }
}

export default CompatibleWith;
